module.exports = __webpack_public_path__ + "static/media/WechatCusomerService.d073fe9b.png";